export const TOGGLE_WEBTOUR_OVERLAY = 'TOGGLE_WEBTOUR_OVERLAY';
export const COMMUNICATE = 'COMMUNICATE';
export const APPLY_ONLINE = 'APPLY_ONLINE';
export const LEARN_MORE = 'LEARN_MORE';
export const SET_LOGO_FILE = 'SET_LOGO_FILE';
export const SET_LOGO_S3_SCANNED_URI = 'SET_LOGO_S3_SCANNED_URI';
export const SET_CROPPED_LOGO_FILE = 'SET_CROPPED_LOGO_FILE';
export const ADD_LEARN_MORE_LINK = 'ADD_LEARN_MORE_LINK';
export const EDIT_LEARN_MORE_LINK = 'EDIT_LEARN_MORE_LINK';
export const INITIALIZE_CUSTOM_PROFILES = 'INITIALIZE_CUSTOM_PROFILES';
export const UPDATE_CUSTOM_PROFILES = 'UPDATE_CUSTOM_PROFILES';
export const REMOVE_CUSTOM_PROFILE = 'REMOVE_CUSTOM_PROFILE';
export const ADD_CUSTOM_PROFILE = 'ADD_CUSTOM_PROFILE';
export const RESET_NON_PERSISTENT_COLLEGE_PROFILE = 'RESET_NON_PERSISTENT_COLLEGE_PROFILE';
export const SET_ARE_NEW_LINKS = 'SET_ARE_NEW_LINKS';
export const SET_REQUEST_INFO_LINK = 'SET_REQUEST_INFO_LINK';
export const SET_APPLY_ONLINE_LINK = 'SET_APPLY_ONLINE_LINK';
export const SET_LEARN_MORE_LINKS = 'SET_LEARN_MORE_LINKS';
export const SET_NEXT_LINK_ORDER = 'SET_NEXT_LINK_ORDER';
export const REMOVE_LEARN_MORE_LINK = 'REMOVE_LEARN_MORE_LINK';
export const EDIT_VIDEO_PROFILE_LINK = 'EDIT_VIDEO_PROFILE_LINK';
export const SET_ABOUT_US_DATA = 'SET_ABOUT_US_DATA';
export const DELETE_ABOUT_US = 'DELETE_ABOUT_US';
export const DELETE_MEDIA_ITEM = 'DELETE_MEDIA_ITEM';
export const INITIALIZE_MEDIA = 'INITIALIZE_MEDIA';
export const SAVE_PHOTO_CAPTION = 'SAVE_PHOTO_CAPTION';
export const SAVE_NEW_PHOTO = 'SAVE_NEW_PHOTO';
export const SET_PHOTO_S3_SCANNED_URI = 'SET_PHOTO_S3_SCANNED_URI';
export const SET_CROPPED_PHOTO_FILE = 'SET_CROPPED_PHOTO_FILE';
export const SET_VIDEO = 'SET_VIDEO';
export const RESET_INTRO_CHANGES_FLAG = 'RESET_INTRO_CHANGES_FLAG';
export const RESET_MEDIA_CHANGES_FLAG = 'RESET_MEDIA_CHANGES_FLAG';
export const RESET_LINKS_AND_PROFILES_CHANGES_FLAG = 'RESET_LINKS_AND_PROFILES_CHANGES_FLAG';
export const SET_ABOUT_US_PHOTO_FILE = 'SET_ABOUT_US_PHOTO_FILE';
export const SET_ABOUT_US_PHOTO_S3_SCANNED_URI = 'SET_ABOUT_US_PHOTO_S3_SCANNED_URI';
export const SET_ABOUT_US_CROPPED_PHOTO_FILE = 'SET_ABOUT_US_CROPPED_PHOTO_FILE';
export const SET_PROFILE_PHOTO_FILE = 'SET_PROFILE_PHOTO_FILE';
export const SET_PROFILE_PHOTO_S3_SCANNED_URI = 'SET_PROFILE_PHOTO_S3_SCANNED_URI';
export const SET_PROFILE_CROPPED_PHOTO_FILE = 'SET_PROFILE_CROPPED_PHOTO_FILE';

// HUBS profile type names
export const COLLEGE_PROFILE_TYPE_NAME_ALUMNI = 'alumni';
export const COLLEGE_PROFILE_TYPE_NAME_COLLEGE = 'college';
export const COLLEGE_PROFILE_TYPE_NAME_FACULTY = 'faculty';
export const COLLEGE_PROFILE_TYPE_NAME_PARENT = 'parent';
export const COLLEGE_PROFILE_TYPE_NAME_PROGRAM = 'program';
export const COLLEGE_PROFILE_TYPE_NAME_SCHOOL = 'school';
export const COLLEGE_PROFILE_TYPE_NAME_STUDENT = 'student';

export const BASIC_INFO_TAB = 'BASIC_INFO_TAB';
export const INTRO_TAB = 'INTRO_TAB';
export const MEDIA_TAB = 'MEDIA_TAB';
export const LINKS_AND_PROFILES_TAB = 'LINKS_AND_PROFILES_TAB';
export const DEFAULT_CONTENT_TYPE = 'hubs';
export const CAMINO_CONTENT_TYPE = 'camino';
export const CAMINO_MENU_TYPE = 'transferInfo';

export const BASIC_INFO_TAB_IDX = 0;
export const INTRO_TAB_IDX = 1;
export const MEDIA_TAB_IDX = 2;
export const LINKS_AND_PROFILES_TAB_IDX = 3;

export const SVG_IMAGE_CODE = '3C3F786D';
export const PNG_IMAGE_CODE = '89504E47';
export const GIF_IMAGE_CODE = '47494638';
// https://jpeg.org/
export const JPG_IMAGE_CODE = 'FFD8FF';

// BASIC_INFO
export const SET_INITIAL_BASIC_INFO_STATE = 'SET_INITIAL_BASIC_INFO_STATE';
export const SET_BASIC_INFO_LOADED_STATE = 'SET_BASIC_INFO_LOADED_STATE';
export const UPDATE_BASIC_INFO_FIELD_DATA = 'UPDATE_BASIC_INFO_FIELD_DATA';
export const ADD_BASIC_INFO_FIELD_DATA = 'ADD_BASIC_INFO_FIELD_DATA';
export const REMOVE_BASIC_INFO_FIELD_DATA = 'REMOVE_BASIC_INFO_FIELD_DATA';
export const UPDATE_BASIC_INFO_OPTIONS = 'UPDATE_BASIC_INFO_OPTIONS';
export const SET_BASIC_INFO_IS_INVALID = 'SET_BASIC_INFO_IS_INVALID';
export const RESET_BASIC_INFO = 'RESET_BASIC_INFO';

export const SET_INITIAL_CMS_DATA_STATE = 'SET_INITIAL_CMS_DATA_STATE';
export const SET_CMS_DATA_IS_INVALID = 'SET_CMS_DATA_IS_INVALID';
export const UPDATE_CMS_RAW_DATA = 'UPDATE_CMS_RAW_DATA';
export const RESET_CMS_DATA = 'RESET_CMS_DATA';
